import { faBolt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";

import { Price } from "@shared/components/Price";

import * as styles from "./PricingInformation.styles";

interface Props {
  msrp?: number;
  sellPrice?: number;
  currencySymbol?: "CAN" | "US";
  isPromoActive?: boolean;
}

const PricingInformation: FC<Props> = ({ msrp, sellPrice, currencySymbol, isPromoActive }) => {
  const renderPromoBolt = () => {
    if (!isPromoActive) return null;
    return <FontAwesomeIcon icon={faBolt} css={styles.svg} />;
  };

  const renderPrice = () => {
    if (!sellPrice || msrp === sellPrice) {
      return (
        <span css={styles.sellPrice}>
          <Price price={msrp} data-testid="msrp" data-e2e="msrp" currencySymbol={currencySymbol} />
        </span>
      );
    } else if (!msrp) {
      return (
        <span css={styles.sellPrice}>
          {renderPromoBolt()}
          <Price
            price={sellPrice}
            data-testid="sellPrice"
            data-e2e="sell-price"
            currencySymbol={currencySymbol}
          />
        </span>
      );
    } else {
      return (
        <>
          <s css={styles.msrp} data-testid="strike">
            <Price
              price={msrp}
              data-testid="msrp"
              data-e2e="msrp"
              currencySymbol={currencySymbol}
            />
          </s>
          <span css={styles.sellPrice}>
            {renderPromoBolt()}
            <Price
              price={sellPrice}
              data-testid="sellPrice"
              data-e2e="sell-price"
              currencySymbol={currencySymbol}
            />
          </span>
        </>
      );
    }
  };

  return renderPrice();
};

export { PricingInformation };
